const DIGIT_CANDIDATE = /(?<!\d)(?:\d[ -]?){12,18}\d(?!\d)/g;
const CARD_CONTEXT = /card|pan|payment|credit|debit/i;

export function isLuhnValid(value: string): boolean {
  const digits = value.replace(/\D/g, '');
  if (digits.length < 13 || digits.length > 19 || /^([0-9])\1+$/.test(digits)) return false;

  let sum = 0;
  let double = false;
  for (let index = digits.length - 1; index >= 0; index -= 1) {
    let digit = Number(digits[index]);
    if (double) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    double = !double;
  }
  return sum % 10 === 0;
}

export function redactSecrets(input: string): string {
  let output = input;

  output = output.replace(
    /\b(unlock pattern)\b\s*(?::|is|equals)?\s*([0-9][0-9\s-]{2,})/giu,
    '$1: [REDACTED]',
  );
  output = output.replace(
    /\b(PIN|CVV|CVC)\b\s*(?::|is|equals)?\s*([A-Za-z0-9-]{3,32})/giu,
    '$1: [REDACTED]',
  );
  output = output.replace(
    /\b(password|passcode)\b\s*(?::|is|equals)?\s*(\S+)/giu,
    '$1: [REDACTED]',
  );

  output = output.replace(DIGIT_CANDIDATE, (candidate, offset: number, source: string) => {
    const digits = candidate.replace(/\D/g, '');
    const contextStart = Math.max(0, offset - 32);
    const contextEnd = Math.min(source.length, offset + candidate.length + 32);
    const context = source.slice(contextStart, contextEnd);
    if (!isLuhnValid(digits) && !CARD_CONTEXT.test(context)) return candidate;
    return `**** **** **** ${digits.slice(-4)}`;
  });

  return output;
}

export function redactTranscript<T extends { text: string }>(entries: readonly T[]): T[] {
  return entries.map((entry) => ({ ...entry, text: redactSecrets(entry.text) }));
}
